import { useEffect } from "react";
import defaultProfilePicture from "@ht/shared/images/img1.jpg";
import { IResponse } from '../../../hooks/useHttp';
import { useAppDispatch } from "../../../app/hooks";
import { unreadNotification } from "../../../app/chat/chatSlice";
import { useHttpRequest } from "../../../hooks/useHttpRequest";

export const useFetchUnreadNotification = (
    agentUsername: string,
    limit: number,
    tenantId: string,
) => {
    const dispatch = useAppDispatch();
    const chatBaseUrl = String(process.env.REACT_APP_CHAT_SERVICE);
    const unReadChatUrl = `/chat/UnreadChat/${agentUsername}/?limit=${limit}&tenantid=${tenantId}`;
    const { error, loading, sendRequest } = useHttpRequest(chatBaseUrl);
    const retrieveData = (res: IResponse | undefined) => {
        const data = res?.data;
        const messages = data?.map(item => {
            return {
                roomId: item.room_id,
                messageId: item.message_id,
                message: item.message,
                messageType: item.message_type,
                messageTime: item.message_time,
                minMessageTime: item.min_message_time,
                messageFiles: item.message_files,
                messageRead: item.message_read,
                roomOwner: item.room_owner,
                senderId: item.sender_id,
                senderName: item.sender_name,
                avatar: { src: defaultProfilePicture },
                sessionId: item.session_id,
                isSent: true,
                originalMessageId: item.original_message_id,
                parentId: item.parent_id,
                feature: item.feature,
                replyTo: item.reply_to,
                campaignId: item.campaign_id ?? 0
            }
        }) ?? [];
        dispatch(unreadNotification(messages));
    }

    const request = async () => {
        const response = await sendRequest({
            url: unReadChatUrl, method: "get"
        });
        retrieveData(response);
    }

    useEffect(() => {
        if (agentUsername && tenantId && limit)
            request().catch(e => console.log(e));
    }, [agentUsername, tenantId, limit])

    return { error, loading, retrieveData, unReadChatUrl, chatBaseUrl };
};
